import { get, post, put, del } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const deviceTypeService = {
  search:  (params)       => get(ENDPOINTS.deviceTypes.search, { params }),
  create:  (data)         => post(ENDPOINTS.deviceTypes.list, data),
  update:  (id, data)     => put(ENDPOINTS.deviceTypes.byId(id), data),
  remove:  (id)           => del(ENDPOINTS.deviceTypes.byId(id)),
};
